var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fans-layout"},[_c('FansHeader',{ref:"FansHeader",staticClass:"FansHeader",class:{ 'ON':_vm.isShow},attrs:{"nav-color":"_black"}}),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('no-ssr',[_c('Login'),_vm._v(" "),_c('GlobalSlot'),_vm._v(" "),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }